export default "__VITE_ASSET__CTTMY$6t__"